import { apiUrl } from '../api';
import { roundToTwo } from '../formatting';
import { showToast } from '../ui.js';
import { createLogger } from '../../../shared/logger';

export const VIEW_MODES = {
  USER: 'user',
  SUPERADMIN: 'superadmin',
} as const;

export const log = createLogger('portal:api-operations');

export { apiUrl, roundToTwo, showToast };
